import React from "react";
import { useLocation, Link } from "react-router-dom"; // Step 1: Import Link
import { CBreadcrumb, CBreadcrumbItem } from "@coreui/react-pro";

const Breadcrumb = () => {
  const currentLocation = useLocation().pathname;

  const capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);
  const formatBreadcrumbName = (segment) => {
    if (segment === "audit-logs") {
      return "Audit Logs";
    }
    return segment
      .split("-")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  };
  const getBreadcrumbs = (location) => {
    if (location === "/dashboard") {
      return [
        {
          pathname: "/dashboard",
          name: "Dashboard",
          active: true,
        },
      ];
    }

    const pathSegments = location.split("/").filter(Boolean);
    const breadcrumbs = pathSegments.map((segment, index, array) => ({
      pathname: `/${array.slice(0, index + 1).join("/")}`,
      name: formatBreadcrumbName(segment),
      active: index + 1 === array.length,
    }));

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(currentLocation);

  return (
    <CBreadcrumb className="m-0">
      {breadcrumbs
        .filter((breadcrumb) => breadcrumb.name !== "Undefined")
        .map((breadcrumb, index) => (
          <CBreadcrumbItem active={breadcrumb.active} key={index}>
            {breadcrumb.active ||
            breadcrumb.name === "Details" ||
            breadcrumb.name === "Edit" ||
            breadcrumb.name === "Inquiry" ||
            breadcrumb.name === "Api" ||
            breadcrumb.name === "Product" ||
            breadcrumb.name === "Purchase" ||
            breadcrumb.name === "Upload Policy" ||
            breadcrumb.pathname === "/requests/upload-quotation" ||
            breadcrumb.name === "Upload Quotation" ||
            (index > 0 &&
              breadcrumbs[index - 1].name === "Upload Quotation") ? (
              breadcrumb.name
            ) : (
              <Link to={breadcrumb.pathname}>{breadcrumb.name}</Link>
            )}
          </CBreadcrumbItem>
        ))}
    </CBreadcrumb>
  );
};

export default React.memo(Breadcrumb);
